import React, {Fragment} from "react";
import {Garage} from "@App/types";
import {Text} from "@eo-locale/react";


export type GarageProfileAboutProps = {
    garage: Garage
};

export const  GarageProfileAbout = React.memo<GarageProfileAboutProps>(({garage}) => {

    return (
        <Fragment>
        {garage.description && (
                <div className={'garageProfile:_about col-span-full mb-10'}>
                    <h2 className={'text-3xl font-serif mb-8'}>Über {garage.name}</h2>
                    <div className={'mt-5 profileText overflow-hidden'} dangerouslySetInnerHTML={{ __html: garage.description.replace(/(<div|(<\/?p)|(<\/?strong)|(<\/?h)([0-6])|<b(?!r))[^>]*>?/gm, "") }}/>
                </div>
            )}
        </Fragment>
    )
})

GarageProfileAbout.displayName = 'GarageProfileAbout';
